import { render } from "./AddLocal.vue?vue&type=template&id=30f8874f&scoped=true"
import script from "./AddLocal.vue?vue&type=script&lang=js"
export * from "./AddLocal.vue?vue&type=script&lang=js"

import "./AddLocal.vue?vue&type=style&index=0&id=30f8874f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30f8874f"

export default script